import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

import { ActivatedRoute, Router } from '@angular/router';
import { Onderneming } from '../models/Onderneming';
import { timeInterval } from 'rxjs/operators';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor( ) {}
  previousRoute: string;
  previousRouteId:string;
  ngOnInit(): void {
    this.previousRoute = JSON.parse(localStorage.getItem('onderneming'));
    //this.previousRouteId = JSON.parse(localStorage.getItem('ondernemingId'));
    // setTimeout(() => {
    //   if(this.previousRoute && this.previousRouteId)
    //   {
    //     this.router.navigate(['/login']);
    //     console.log("ERROR IN AUTH SERVICE ");
    //   }
    //   else
    //   {
    //     this.router.navigate(["/", pathNaam, pathId,"tools"]);
    //   }
      
    // }, 2500);
  }
}
